// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CardLarge_cardWrapper__6pLUu","cardOverlay":"CardLarge_cardOverlay__Bl8Dk","visibleContent":"CardLarge_visibleContent__6iyF8"};